import Cell from "overprint/overprint/cell";

const Glyphs = {
  EMPTY: Cell(" "),
  PLAYER: Cell("@", "white"),
  MONSTER: Cell("M", "#0C9"),
  GREMLIN: Cell("g", "#0C9"),
  LIT: {
    WALL: Cell("#", "#aaa"),
    FLOOR: Cell(".", "#6C90B9", "#1F6683")
  },
  UNLIT: {
    WALL: Cell("#", "#555"),
    FLOOR: Cell(".", "#6C90B9", "#313657")
  },
  SAND: Cell(";", "#BC8E7D", "#FAE093")
}

export default Glyphs;
